import TruncateTooltip from "@/components/truncate-with-tooltip"
import { Box, Typography } from "@mui/material"
import moment from "moment"

const TitleColumn = (props) => {
    const data = props?.row?.data
    const { start = "", end = "", selectedTimeZone = "", title = "" } = data

    const getFormatted = (date, format) => {
        return moment(date).format(format)
    }
    return (<Box>
        <Box>
            <Typography 
                variant="body2"
                sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "290px",
                    lineHeight: 1.2,
                }}
            >{title}</Typography>
        </Box>
        <TruncateTooltip
            position="top"
            limit={80}
            text={`${getFormatted(start, "ddd, MMMM D, yy,")} 
            ${getFormatted(start, "hh:mm A")} 
            ${getFormatted(end, "hh:mm A")} 
            ${selectedTimeZone}`}
            sx={{
                color: "var(--base-80)",
                fontSize: "0.75rem",
                lineHeight: 1.2,
            }}
        />
    </Box>)
}

export default TitleColumn